<template>
  <div :class="['alert-baby', { 'alert-baby--menu': menu }]">
    <p>
      <strong><u>IMPORTANT</u></strong> : Nous accueillons bientôt notre 2ème princesse ! ❤️🍼
      <br />Mon congé maternité commence le <strong>4 décembre</strong>, il ne sera donc plus possible de passer
      commande jusqu'au <strong>27 mars.</strong>
      <br />
      J’espère vous retrouver aussi nombreux.ses à mon retour ! Hélène.


      <br v-if="nbDaysLeft > 0" />

      <strong v-if="!onHolidays" class="alert-baby__obvious">
        <span v-if="!lessThan1Day && nbDaysLeft > 0">
          Plus que {{ nbDaysLeft }} jour<span v-if="nbDaysLeft > 1">s</span>
          pour passer commande.
        </span>

        <span v-if="lessThan1Day && nbDaysLeft > 0">
          Plus que quelques heures pour passer commande.
        </span>
      </strong>

      <strong v-else-if="onHolidays" class="alert-baby__obvious">
        <span v-if="!lessThan1DayBeforeWork && nbDaysLeft > 0">
          Plus que {{ nbDaysLeft }} jour<span v-if="nbDaysLeft > 1">s</span>
          avant la reprise des commandes.
        </span>

        <span v-if="lessThan1DayBeforeWork && nbDaysLeft > 0">
          Plus que quelques heures avant la reprise des commandes.
        </span>
      </strong>
    </p>
  </div>
</template>

<script>
import alertBaby from '../../mixins/alertBaby';

export default {
  props: {
    menu: {
      type: Boolean,
      default: false,
    },
  },

  mixins: [alertBaby],
};
</script>
